import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { SxHttpService } from './sxHttp.service';
import { ViewEngine } from '../model/classes/viewEngine.class';
import { AzureFile } from '../model/interfaces/azureFile.Interface';
import { TemplateListadoItem } from '../model/classes/templateListadoItem.class';

@Injectable()
export class ViewEngineService {
    private viewEngineUrl = 'api/viewEngine';

    constructor(private sxHttp: SxHttpService) { }

    getForList(): Observable<TemplateListadoItem[]> {
        return this.sxHttp
          .get(`${this.viewEngineUrl}/GetAll`)
          .map(response => {
            return response.json().data.map(output => {
              return {
                id: output.codViewEngine,
                    titulo: output.title,
                    subtitulo: output.description,
                    outputs:output.outputs
              };
            }) as TemplateListadoItem[];
          });
      }

      getFiles( codViewEngine: string): Observable<AzureFile[]> {
        const url = `${this.viewEngineUrl}/${codViewEngine}/files`;

        return this.sxHttp.get(url).map(response => {
            const components = response.json().data;
            return components.map(component => component as AzureFile);
        });
    }

    save(request: any, alias: string): Promise<ViewEngine> {
        const url = `${this.viewEngineUrl}/${alias}/${request.component.codViewEngine}`;
        
        return this.sxHttp
            .post(url, request)
            .toPromise()
            .then(response => response.json().data as ViewEngine);
    }

    get(codViewEngine: string): Observable<ViewEngine> {
        return this.sxHttp
            .get(this.viewEngineUrl + '/Get/' + codViewEngine )
            .map(response => response.json().data as ViewEngine);
    }
    
    getByIdAndStatus(codViewEngine: string): Observable<ViewEngine> {
        return this.sxHttp
            .get(this.viewEngineUrl + '/GetByIdAndStatus/' + codViewEngine )
            .map(response => response.json().data as ViewEngine);
    }
    create(viewEngine: ViewEngine): Promise<ViewEngine> {
        return this.sxHttp
            .post(this.viewEngineUrl, viewEngine)
            .toPromise()
            .then(response => response.json().data as ViewEngine);
    }

    edit(codViewEngine, output: ViewEngine): Promise<ViewEngine> {
        return this.sxHttp
            .put(
                this.viewEngineUrl + '/' + codViewEngine ,
                output
            )
            .toPromise()
            .then(response => response.json().data as ViewEngine);
    }

    delete(codViewEngine: string): Observable<any> {
        return this.sxHttp
            .delete(this.viewEngineUrl + '/' + codViewEngine +"/Delete" )
            .map(result => result.json().data);
    }

    getOrganizationList(): Observable<ViewEngine> {
        return this.sxHttp
          .get(this.viewEngineUrl + "/GetOrganizationList")
          .map((response) => {
            return response.json().data as ViewEngine;
          });
      }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/viewengine.service.ts